import { useCallback, useEffect, useMemo, useState } from "react";
import { ContentsTitle } from "src/components";
import { BaseAbstractModal } from "src/components/BaseAbstractModal";
import ContractMemberFind from "src/pages/commonPopup/components/ContractMemberFind";
import TaapMemberFind from "./TaapMemberFind";

/**
 * 계약자 변경 모달의 props 인터페이스
 * @param isOpen 모달 표시 여부
 * @param memberInfo 회원 정보
 * @param onClick 선택 콜백 함수
 * @param onClose 모달 닫기 콜백 함수
 */
interface MemberProps {
  isOpen: boolean;
  memberInfo: any;
  onClick: any;
  onClose: any;
}

/**
 * 계약자 변경 모달 컴포넌트
 * 계약자를 변경하기 위한 모달 컴포넌트입니다.
 * 이용자와 Taap회원 중에서 선택할 수 있습니다.
 * @param isOpen 모달 표시 여부
 * @param memberInfo 회원 정보
 * @param onClick 선택 콜백 함수
 * @param onClose 모달 닫기 콜백 함수
 */
const ContractorChangeModal = ({ isOpen, memberInfo, onClick, onClose }: MemberProps) => {
  // 현재 활성화된 탭 상태
  const [activeTab, setActiveTab] = useState<any>({ label: "이용자", value: "member" });

  // 탭 목록 정의
  const tabs = useMemo(() => {
    return [
      { label: "이용자", value: "member" },
      { label: "Taap회원", value: "taap" },
    ];
  }, []);

  /**
   * 탭 클릭 처리 함수
   * @param tab 선택된 탭 정보
   */
  const clickTab = useCallback(async (tab: { value: string; label: string; disabled: boolean }) => {
    setActiveTab(tab);
  }, []);

  useEffect(() => {}, []);
  console.log("activeTabs", activeTab);
  return (
    <div>
      <BaseAbstractModal size="xlarge" isOpen={isOpen}>
        <section className="base-abstract-modal__title">
          <div className="flex-row flex-center-between w-100">
            <h1>계약자 선택</h1>
          </div>
        </section>
        <ContentsTitle title="신청/계약" tabs={tabs} activeTab={activeTab} clickTab={clickTab} colorType={"contract"} />

        {activeTab.value === "member" && (
          <ContractMemberFind isOpen={isOpen} contractManageId={memberInfo.contractManageId!} onClick={onClick} onClose={onClose} />
        )}

        {activeTab.value === "taap" && (
          <TaapMemberFind isOpen={isOpen} memberInfo={memberInfo.contractManageId!} onClick={onClick} onClose={onClose} size="xlarge" />
        )}
      </BaseAbstractModal>
    </div>
  );
};
export default ContractorChangeModal;
